import React from 'react';
import Layout from '../Components/Layout/Layout';
import CategoryPage from '../Components/Category/CategoryPage';

function CategoryPageRoute() {
  return (
    <Layout>
      <CategoryPage />
    </Layout>
  );
}

export default CategoryPageRoute;
